<template>
  <div :class="request_prefix === 'bigScreen' ? 'data-center-choose bigScreen' : 'data-center-choose'">
    <div v-if="appId" class="data-selector checked" @click="goToChooseData">
      <span class="icon-portal-dynamic-data icon1"></span>
      <span class="title">{{ options.dataCenterName }}</span>
      <div class="icon-portal-right-up icon2"></div>
    </div>
    <div v-else class="data-selector" @click="goToChooseData">
      <span class="icon-portal-add1 icon1"></span>
      <span class="title">请选择</span>
      <div class="icon-portal-right-up icon2"></div>
    </div>
    <el-drawer
      :visible.sync="dataOpened"
      :with-header="false"
      :modal="false"
      :append-to-body="true"
      size="100%"
      destroy-on-close
    >
      <div id="dataSetting" style="height: 100%"></div>
    </el-drawer>
  </div>
</template>

<script>
import { loadMicroApp } from "qiankun"
import actions from "utils/actions"
export default {
  name: "data-center-choose",
  props: {
    options: {
      type: Object
    },
    checkStatus: {
      type: Boolean | String
    },
    // 存储数据源信息组件id
    myId: {
      type: Object
    },
    // 数据源id，针对地图里的热力图等组件
    getId: {
      type: Function | undefined
    },
    // 数据源生成时，额外的条件
    extraQuery: {
      type: Boolean,
      default: true
    },
    // 图表类型或者普通类型数据
    type: {
      type: String,
      default: "general"
    },
    // true：点击后直接跳转，false：需要判断是本地数据还是数据中心数据。再跳转
    jumpDirect: {
      type: Boolean,
      default: false
    },
    onBeforeDataCenterUpdate: {
      type: Function,
      default: () => {}
    },
    onAfterDataCenterUpdate: {
      type: Function,
      default: () => {}
    },
    onAfterDataCenterChoose: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      fetchEnd: false,
      dataOpened: false,
      isLocal: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    appId() {
      const ids = this.getId ? this.getId() : this.ids
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], ids)
      const appId = rectAttr.options?.appId || rectAttr.options?.myFetchParam?.appId || rectAttr.appId
      return appId
    }
  },
  mounted() {
    this.initAppInfomation()
    actions.onGlobalStateChange(state => {
      if (!state.dataOpened) {
        window.dataCenterSingle?.unmount()
        window.dataCenterSingle = null
        if (state.save) {
          this.initAppInfomation()
          this.$emit("onDataCenterChange")
          this.$eventBus.$emit("data-center-change")
        }
        this.dataOpened = !!state.dataOpened
      } else {
        this.dataOpened = !!state.dataOpened
      }
    })
  },
  beforeDestroy() {
    actions.offGlobalStateChange()
  },
  methods: {
    goToChooseData() {
      if (this.fetchEnd) {
        return
      }
      this.fetchEnd = true
      const { websiteId, pageId, formId } = this.$store.state.states.getDataPageIds
      const ids = this.getId ? this.getId() : this.ids
      if (!this.appId && this.extraQuery) {
        this.$saveModule(ids, "31CB73E03E24BBFF", "临时", this.type === "chart_screen")
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              this.$emit("onAfterDataCenterChoose", res.appId)
              this.openDataSetting(res.appId, websiteId, pageId, formId)
            }
          })
          .catch(err => {
            this.fetchEnd = false
          })
      } else {
        this.fetchEnd = false
      }
      if (this.appId) {
        this.$emit("onAfterDataCenterChoose", this.appId)
        this.openDataSetting(this.appId, websiteId, pageId, formId)
      }
    },
    async openDataSetting(appId, websiteId, pageId, formId) {
      if (this.jumpDirect || !this.isLocal) {
        actions.setGlobalState({
          dataOpened: true
        })
        const res = await this.$API.getDataCenterUrl({
          appId,
          type: this.type,
          w: websiteId,
          p: pageId
        })
        let url = res.data.data
        if (url) {
          if (this.request_prefix === "bigScreen") {
            url += "&theme=dark"
          }
          // 表单数据源支持数据过滤，需要传递表单id
          if (formId) {
            url += `&pageFormId=${formId}`
          }
          url += `&t=${(new Date()).getTime()}`
          window.dataCenterUrl = url
          window.dataCenterSingle = loadMicroApp(
            {
              name: "data-management",
              entry: url,
              container: "#dataSetting",
              props: {
                url
              }
            },
            {
              singular: true
            }
          )
        }
      } else {
        let url = `/engine2/data/api-v2/admin/${this.type}/${appId}?w=${websiteId}&p=${pageId}`
        window.open(url)
      }
    },
    async initAppInfomation() {
      this.$emit("onBeforeDataCenterUpdate")
      if (!this.checkStatus) {
        return false
      }
      try {
        const appId = this.options.appId ? this.options.appId : this.options.myFetchParam?.appId
        if (appId) {
          const res = await this.$API.getContentConfig({ appId, engineType: this.type })
          const { name, typeId } = res.data.data.content
          const engineInstance = res.data.data.engineInstance
          const { source } = engineInstance
          this.isLocal = source === 1
          this.$changeOptionsEV(name, "dataCenterName", false, null, this.myId, true)
          this.$emit("onAfterDataCenterUpdate", source, typeId, engineInstance)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.data-center-choose {
  .data-selector {
    height: 32px;
    padding: 0px 8px 0px 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.1);
    &:hover {
      cursor: pointer;
      background-color: rgba(36, 0, 255, 0.2);
    }
    .icon1 {
      font-size: 16px;
      color: rgba(36, 0, 255, 0.5);
    }
    &.checked .icon1,
    &.checked .title {
      color: rgba(36, 0, 255, 1);
    }
    .title {
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      color: rgba(36, 0, 255, 0.5);
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .icon2 {
      margin-left: auto;
      font-size: 16px;
      color: rgba(36, 0, 255, 1);
    }
  }
  &.bigScreen .data-selector {
    border: 1px solid rgba(166, 139, 255, 0.16);
    background-color: rgba(166, 139, 255, 0.1);
    &:hover {
      background-color: rgba(166, 139, 255, 0.2);
    }
    .icon1,
    .title,
    .icon2 {
      color: rgba(166, 139, 255, 0.5);
    }
    &.checked .icon1,
    &.checked .title,
    &.checked .icon2 {
      color: rgba(166, 139, 255, 1);
    }
  }
}
</style>
